export const bankLogoData = {
	농협은행: '/assets/images/banks/nh.svg',

	KB국민은행: '/assets/images/banks/kb.svg',

	신한은행: '/assets/images/banks/sinHan.svg',

	카카오뱅크: '/assets/images/banks/kakaoBank.svg',

	우리은행: '/assets/images/banks/woori.svg',

	하나은행: '/assets/images/banks/hana.svg',

	토스뱅크: '/assets/images/banks/toss.svg',

	새마을금고: '/assets/images/banks/saeMaul.svg',

	IBK기업은행: '/assets/images/banks/ibk.svg',

	케이뱅크: '/assets/images/banks/kbank.svg',

	우체국: '/assets/images/banks/postOffice.svg',

	SC제일은행: '/assets/images/banks/sc.svg',

	전북은행: '/assets/images/banks/jb.svg',

	신협: '/assets/images/banks/sinhyep.svg',

	경남은행: '/assets/images/banks/gn.svg',

	광주은행: '/assets/images/banks/gj.svg',

	부산은행: '/assets/images/banks/bs.svg',

	수협은행: '/assets/images/banks/soohyep.svg',

	KDB산업은행: '/assets/images/banks/kdb.svg',

	대구은행: '/assets/images/banks/dg.svg',

	산림조합은행: '/assets/images/banks/sj.svg',

	제주은행: '/assets/images/banks/jj.svg',
};
